import {mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums";
import moment from "moment-timezone";

const timezone = 'Asia/Kolkata';
export const getFormData = (data) => {
    const initialData = {
        fName: '',
        lName: '',
        email: '',
        password: 'Sest@1234',
        phone: '',
        gender: '',
        gstNumber: '',
        address: {
            "officeNo": '',
            "floor": undefined,
            "address": '',
        }
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {
            header: "Name",
            field: "fName",
            render: (item) => {
                return <>{item.fName}{item?.lName ? ` ${item.lName}` : ''}</>;
            },
        },
        {header: "Phone", field: "phone"},
        {header: "Email", field: "email"},
        {header: "Gst number", field: "gstNumber"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} orders={true} edit={true} view={true} onDelete={deleteHandler} restricted={[{BranchManager: ['c']}
        ]}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        fName: item.fName,
        lName: item.lName,
        phone: item.phone,
        email: item.email,
        gstNumber: item.gstNumber,
    }));
};

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            Id: item.id,
            FirstName: item?.fName,
            LastName: item?.lName,
            Phone: item?.phone,
            gstNumber: item?.gstNumber,
            Gender: item?.gender !== null && item?.gender !== undefined ? item?.gender : "",
            OfficeNo: item?.address?.officeNo,
            floor: item?.address?.floor,
            address: item?.address?.address,
            Status: reverseEnum(Status)[item.status],
        },
    };
};

export const getTransactionTableColumns = () => {
    let tableColumns = [
        {header: "Total Amount", field: "totalAmount"},
        {header: "Payment Method", field: "paymentMethod"},
        {header: "Pay At", field: "payAt"},
    ];
    return tableColumns;
};

export const getTransactionTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        totalAmount:item.totalAmount,
        paymentMethod:item.paymentMethod,
        payAt: moment(item.payAt).tz(timezone).format('MMM DD, YYYY, hh:mm A'),
    }));
};
